import { Box } from "@mui/material";
import { styled } from "@mui/material";
import { Poppins } from "next/font/google";

const poppins = Poppins({
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

export const DrawerFooterContainer = styled(Box)(({ theme }) => ({
  padding: "20px 24px",
  display: "flex",
  alignContent: "center",
  position: "relative",
  "& .MuiTypography-root": {
    padding: "0px 70px",
    color: "#979DAC",
    textAlign: "center",
    fontSize: "12px",
    fontWeight: 400,
    fontFamily: poppins.style.fontFamily,
  },
  "& .MuiTypography-root a": {
    color: "#33415C",
    fontSize: "12px",
    fontWeight: 400,
    textAlign: "center",
    textDecoration: "none",
    fontFamily: poppins.style.fontFamily,
  },
  "& .StartButton": {
    position: "absolute",
    left: "12px",
    bottom: "10px",
    fontFamily: poppins.style.fontFamily,
  },
  "& .EndButton": {
    position: "absolute",
    right: "12px",
    bottom: "10px",
    fontFamily: poppins.style.fontFamily,
  },
}));
